import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AdminCommonRepository from "src/repository/Admin/AdminCommonRepository";
import { getForbiddenResponseMessage } from "src/service/forbiddenResponseMessage";

export const getRoleList = createAsyncThunk('get_admin_role_list', async () => {
    try {
        return await new AdminCommonRepository().getRoleList()
    } catch (error) {
        return { records: [], message: getForbiddenResponseMessage(error) }
    }
});

export const getOrgList = createAsyncThunk('get_org_list', async () => {
    try {
        return await new AdminCommonRepository().getOrganizationList()
    } catch (error) {
        return { records: [], message: getForbiddenResponseMessage(error) }
    }
});

const slice = createSlice({
    name: "AdminCommon",
    initialState: {
        roleList: [],
        roleListMessage: '',
        orgList: [],
        orgListMessage: '',
    },
    reducers: {

    },
    extraReducers: {
        [getRoleList.fulfilled]: (state, { payload }) => {
            state.roleList = payload.records || payload;
            state.roleListMessage = payload.message || '';
        },
        [getOrgList.fulfilled]: (state, { payload }) => {
            state.orgList = payload.records || payload;
            state.orgListMessage = payload.message || '';
        },

    },
});



export let { } = slice.actions;

export default slice.reducer;
